import React from "react";
import svg185 from "../../../../assets/svg/svg185.svg";

function PaymentStruggles({ struggles }) {
  return (
    <div className="bg-sec w-full">
      <div className="lg:px-[5.69rem] px-3 py-[4.94rem]">
        <div className="flex flex-col lg:flex-row justify-between gap-[2rem] lg:gap-[3rem] lg:items-stretch">
          {/* Left */}
          <div className="flex flex-col w-full lg:max-w-[50%]">
            <div className="text-ink font-lexend text-[2rem] font-[500] leading-[2.625rem] tracking-[-0.0405rem]">
              {struggles?.title}
            </div>

            <div className="mt-[2rem] grid grid-cols-1 sm:grid-cols-2 gap-x-[2.5rem] gap-y-[1.25rem]">
              {struggles?.items?.map((item, i) => (
                <div key={i} className="flex items-center gap-[.75rem]">
                  <img src={svg185} alt="check" className="flex-shrink-0" />
                  <span className="text-ink font-lexend text-[1rem] font-[400] leading-[1.75rem] tracking-[-0.0175rem]">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="w-full lg:max-w-[40%] lg:self-start">
            <img
              src={struggles?.img}
              alt="payment struggles"
              loading="lazy"
              className="w-full lg:max-h-[20rem] h-auto object-cover rounded-[1.25rem]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentStruggles;
